import SearchIcon from '@atlaskit/icon/core/search';
import { Box, xcss } from '@atlaskit/primitives';
import Textfield from '@atlaskit/textfield';
import React, { type FunctionComponent, type Ref, useCallback } from 'react';

const searchInputContainerStyles = xcss({
  width: '100%',
  minHeight: '32px',
  display: 'flex',
  alignItems: 'center',
  borderColor: 'color.border',
  borderStyle: 'solid',
  borderWidth: 'border.width',
  borderRadius: 'radius.medium',
  backgroundColor: 'color.background.input',
  ':hover': {
    backgroundColor: 'color.background.input.hovered'
  },
  ':focus-within': {
    borderColor: 'color.border.focused',
    backgroundColor: 'color.background.input.pressed',
    outlineColor: 'color.border.focused',
    outlineStyle: 'solid',
    outlineWidth: 'border.width.focused',
    outlineOffset: 'space.negative.025'
  }
});

const searchIconWrapperStyles = xcss({
  display: 'inline-flex',
  paddingInlineStart: 'space.100'
});

export const AddFieldMenuSearchInput: FunctionComponent<{
  ariaLabel: string;
  inputRef?: Ref<HTMLInputElement>;
  onChange: (value: string) => void;
  placeholder: string;
  testId: string;
  value: string;
}> = ({ ariaLabel, inputRef, onChange, placeholder, testId, value }) => {
  const handleChange = useCallback(
    (event: React.FormEvent) => {
      onChange((event.target as HTMLInputElement).value);
    },
    [onChange]
  );

  return (
    <Box xcss={searchInputContainerStyles}>
      <Textfield
        ref={inputRef}
        appearance="none"
        testId={testId}
        elemBeforeInput={
          <Box xcss={searchIconWrapperStyles}>
            <SearchIcon label="" />
          </Box>
        }
        placeholder={placeholder}
        value={value}
        onChange={handleChange}
        aria-label={ariaLabel}
        autoComplete="off"
        isCompact
      />
    </Box>
  );
};
